import useEventBus from '@/composables/event-bus';
import useGoalDefaultProps from '@/composables/saved-views/goal-default-props';
import useInMemoryViews from '@/composables/saved-views/in-memory-views';
import useLookupProperty from '@/composables/property/lookup-property/lookup-property';
import useViewGoalCycle from '@/composables/goal-cycle/view-goal-cycle';
import { GOAL_CHILDREN_LIST_VIEW_APPLICATION, VIEWS_SERVICE, VIEW_EVENT_BUS } from '@/lib/constants';
import { computed, provide } from 'vue';
import { filterGoals } from '@/lib/filter/goal/filter';
import { treeHasValue } from '@/lib/filter/scope-tree';
import { viewType } from 'shared/constants.json';

export default function useGoalDetailFilter() {
  provide(VIEW_EVENT_BUS, useEventBus());

  const { defaultProps: filterProps } = useGoalDefaultProps();
  const lookupPropertySvc = useLookupProperty();

  const viewsService = useInMemoryViews({
    defaultProps: filterProps,
    defaultView: {
      isTemp: true,
      viewType: viewType.list,
      params: { props: [], quickFilters: [] },
    },
    application: GOAL_CHILDREN_LIST_VIEW_APPLICATION,
  });
  provide(VIEWS_SERVICE, viewsService);

  const { composedSelectedCycles: selectedCycles, changeSelectedGoalCycles } = useViewGoalCycle(viewsService);

  const currentView = viewsService.currentView;
  const filter = computed(() => currentView.value.params.filter);
  const filterHasAppliedValue = computed(() => treeHasValue(filter.value));
  const hasActiveFilter = computed(() => selectedCycles.value.length > 0 || filterHasAppliedValue.value);

  const apply = (goals) => filterGoals({
    goals,
    selectedCycles: selectedCycles.value,
    scopeTree: filter.value,
    lookupPropertySvc,
  });

  const reset = () => viewsService.resetView(currentView.value.uid);

  return {
    viewsService,
    currentView,
    filterProps,
    filter,
    filterHasAppliedValue,
    hasActiveFilter,
    selectedCycles,
    changeSelectedGoalCycles,
    apply,
    reset,
  };
}
